var React = require('react');

function CheckedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 7.22312L3.45 10.7001C3.63855 10.9818 3.95158 11.155 4.29037 11.1651C4.62916 11.1752 4.95197 11.021 5.157 10.7511L13 0.828125","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckedInline.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none"};

module.exports = CheckedInline;

CheckedInline.default = CheckedInline;
